import { SHARP_CONSTS } from "./Constant";
export const mandatoryFileds = {
  [SHARP_CONSTS.NEBRASKA_CUSTOMER_ID]: {
    prospectManagement: {
      PlanCampaignName: false,
    },
    enrollmentForm: {
      mailingAddr: true,
      mailingCity: true,
      mailingState: true,
      mailingzip: true,
      premiumType: true,
    },
  },
  [SHARP_CONSTS.VERDA_CUSTOMER_ID]: {
    prospectManagement: {
      PlanCampaignName: true,
    },
    enrollmentForm: {
      mailingAddr: false,
      mailingCity: false,
      mailingState: false,
      mailingzip: false,
      premiumType: false,
    },
  },
  [SHARP_CONSTS.VANILLA_DEMO_CUSTOMER_ID]: {
    prospectManagement: {
      PlanCampaignName: true,
    },
    enrollmentForm: {
      mailingAddr: false,
      mailingCity: false,
      mailingState: false,
      mailingzip: false,
      premiumType: false,
    },
  },
  [SHARP_CONSTS.VANILLA_CUSTOMER_ID]: {
    prospectManagement: {
      PlanCampaignName: true,
    },
    enrollmentForm: {
      mailingAddr: false,
      mailingCity: false,
      mailingState: false,
      mailingzip: false,
      premiumType: false,
    },
  },
};
